import { Minus, Plus } from 'lucide-react'

type Props = {
  servings: number
  onChange: (next: number) => void
  min?:     number
  max?:     number
}

export function RecipeServingsControl({ servings, onChange, min = 1, max = 24 }: Props) {
  const canDecrement = servings > min
  const canIncrement = servings < max

  return (
    <div className="rounded-[14px] border border-border-sand bg-paper px-4 py-3 flex items-center justify-between">
      <div>
        <div className="font-serif text-[13px] italic text-ink-muted">Servings</div>
        <div className="font-serif text-[20px] font-medium text-ink leading-[1.1] mt-0.5">
          {servings}
        </div>
      </div>
      <div className="flex items-center gap-[10px]">
        <button
          onClick={() => canDecrement && onChange(servings - 1)}
          disabled={!canDecrement}
          aria-label="Decrease servings"
          className="h-[30px] w-[30px] rounded-full border border-border-sand bg-paper flex items-center justify-center text-ink disabled:opacity-40"
        >
          <Minus className="h-3 w-3" strokeWidth={2} />
        </button>
        <span className="font-serif text-[20px] font-medium text-ink min-w-[20px] text-center">
          {servings}
        </span>
        <button
          onClick={() => canIncrement && onChange(servings + 1)}
          disabled={!canIncrement}
          aria-label="Increase servings"
          className="h-[30px] w-[30px] rounded-full bg-forest text-forest-ink flex items-center justify-center disabled:opacity-40"
        >
          <Plus className="h-3 w-3" strokeWidth={2} />
        </button>
      </div>
    </div>
  )
}
